import { render, staticRenderFns } from "./PublicationModalForm.vue?vue&type=template&id=26c775ed"
import script from "./PublicationModalForm.vue?vue&type=script&lang=js"
export * from "./PublicationModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports